export const DEMO_I18N_ENTRIES = {
  demo_Data1: {
    es: '<p>Realiza el <span class="i18n-bold">onboarding*</span> y <span class="i18n-bold">paga</span> <span>sólo</span> por kilómetro <span>recorrido</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data2: {
    es: '<p>Solicita una demo totalmente gratuita</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data3: {
    es: '<p>Solicitar ahora</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data4: {
    es: '<p>Introduce tus datos</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data5: {
    es: '<p>Nombre*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data6: {
    es: '<p>Email*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data7: {
    es: '<p>He leído y acepto las</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data8: {
    es: '<p>condiciones de uso.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data9: {
    es: '<p>Acepto recibir comunicaciones comerciales relacionadas con la entidad <span class="i18n-bold">eyesNroad</span> a través de correo electrónico.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data10: {
    es: '<p>Gracias por solicitar la demo, te contactaremos a la mayor brevedad posible</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data11: {
    es: '<p>Solicitar de nuevo</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data12: {
    es: '<p>Rellena el campo correctamente</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  demo_Data13: {
    es: '<p>Ya has solicitado una prueba con este usuario</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
